import { didCancel } from 'ember-concurrency';
import { on } from '@ember/modifier';
import { service } from '@ember/service';
import { t } from 'ember-intl';
import AwayMessageSection from '../away-message-section.gjs';
import BaseRoute from './base-route.gjs';
import Component from '@glimmer/component';
import ConversationListItem from '../conversation-list-item.gjs';
import SharedInfinityLoader from 'ember-simplepractice/components/shared/infinity-loader';
import styles from './conversation-list.module.scss';
import svgJar from 'ember-svg-jar/helpers/svg-jar';

export default class MessagingRoutesConversationList extends Component {
  @service alertManager;
  @service intl;
  @service messagingNavigation;

  get routeHandler() {
    return this.args.handler;
  }

  get conversations() {
    return this.routeHandler.conversations;
  }

  get currentProfile() {
    return this.routeHandler.currentProfile;
  }

  get groupMessagingEnabled() {
    return this.routeHandler.groupMessagingEnabled;
  }

  get headerText() {
    return this.intl.t('emc.navigation.conversation_list', {
      amount: this.currentProfile?.unreadConversationIds?.length || 0,
    });
  }

  loadMoreConversations = async model => {
    try {
      await this.routeHandler.loadMoreConversations.perform(model);
    } catch (err) {
      if (didCancel(err)) return;
      this.alertManager.broadcast('toast', {
        message: this.intl.t('emc.general_error'),
        type: 'error',
      });
    }
  };

  createConversation = () => {
    if (this.groupMessagingEnabled) {
      this.messagingNavigation.toConversationTypeSelection();
    } else {
      this.messagingNavigation.toContacts();
    }
  };

  <template>
    <BaseRoute
      class="{{styles.component}} conversation-list-page"
      data-test-conversation-list-route
    >
      <:header>
        <div class="navigation-bar" data-test-navigation-bar>
          {{svgJar "messaging-locked" class="locked-icon"}}
          <h3 class="navigation-text" data-test-header>{{this.headerText}}</h3>
          {{#if this.currentProfile.isClinician}}
            <button
              class="button transparent new-button"
              type="button"
              data-test-conversation-list-page-new-button
              {{on "click" this.createConversation}}
            >
              {{svgJar "messaging-compose"}}
            </button>
          {{/if}}
        </div>
      </:header>
      <:default>
        {{#if this.currentProfile.isClinician}}
          <AwayMessageSection @onToggleTask={{this.routeHandler.toggleAwayStatus}} />
        {{/if}}

        {{#if this.routeHandler.isLoadingConversations}}
          <div class="spinner" data-test-loading-spinner>
            {{svgJar "messaging-spinner"}}
          </div>
        {{else if this.conversations}}
          <ul class="conversation-list-body" data-test-conversation-list-body>
            {{#each this.routeHandler.sortedConversations as |conversation|}}
              <ConversationListItem @conversation={{conversation}} />
            {{/each}}

            <SharedInfinityLoader
              @model={{this.conversations}}
              @infinityLoad={{this.loadMoreConversations}}
            />
          </ul>
        {{else}}
          <div class="empty-conversation-list" data-test-empty-conversation-list>
            {{svgJar "messaging-welcome"}}
            <h3 class="empty-list-header" data-test-empty-header>{{t "emc.empty_list_header"}}</h3>
            <p class="empty-list-text" data-test-empty-text>{{t "emc.empty_list_text"}}</p>
            {{#if this.currentProfile.isClinician}}
              <button
                class="button primary create-message-button"
                type="button"
                data-test-empty-list-create-message-button
                {{on "click" this.createConversation}}
              >
                Create Message
              </button>
            {{/if}}
          </div>
        {{/if}}
      </:default>
    </BaseRoute>
  </template>
}
